import TextTitleLight from 'components/TextTitleLight'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'

export default function PageSubTitle ({
  children,
  style
}) {
  return (
    <h2
      style={
        getStyleComponentUtil({
          marginBottom: STYLES_MARGIN.MEDIUM
        }, style)
      }
    >
      {
        children && typeof children !== 'string'
          ? children
          : (
            <TextTitleLight fs='body'>
              {children}
            </TextTitleLight>
            )
      }
    </h2>
  )
}
